// extracted by mini-css-extract-plugin
module.exports = {"shareIcon":"PostMenu_shareIcon__5pPPS"};